import { useField } from '@framework/form/field/useField.tsx';
import { useWatch } from 'react-hook-form';
import { useTreeReferencesContext } from '../../../../../../../tree/references/TreeReferencesContext.tsx';
import { useAsyncServiceEngineContext } from '../../../../../../expressions/repository/async/context/AsyncServicesEngineContext.tsx';
import { ExternalServiceConfigForm } from '../../../../common/ExternalServiceConfigForm.tsx';
import { ServiceSelectorInput } from '../../../../inputs/async-select/components/ServiceSelectorInput.tsx';
import { AsyncServiceActionMessageForm } from './AsyncServiceActionMessageForm.tsx';

export interface IButtonActionExecAsyncServiceConfigProps {
  name: string;
}

export function ButtonActionExecAsyncServiceConfig(
  props: IButtonActionExecAsyncServiceConfigProps,
) {
  const { name } = props;
  const { references } = useTreeReferencesContext();
  const { services } = useAsyncServiceEngineContext();

  const selectedId = useWatch({ name: `${name}.serviceId` });
  const selected = services.find(s => s.id === selectedId);

  const { setValue: setLabelField } = useField(`${name}.labelField`);
  const { setValue: setValueField } = useField(`${name}.valueField`);
  const { setValue: setInputsField } = useField(`${name}.inputs`);
  const { setValue: setOutputsField } = useField(`${name}.outputs`);

  return (
    <>
      <div>
        <ServiceSelectorInput
          label="Esegui servizio esterno"
          onChange={(value, option, onChange) => {
            onChange(value);
            setLabelField(null);
            setValueField(null);
            setInputsField({});
            setOutputsField((option as any).service.outputs);
          }}
          name={`${name}.serviceId`}
        />
      </div>
      {selected && (
        <div style={{ paddingTop: '8px' }}>
          <ExternalServiceConfigForm
            name={name}
            selected={selected}
            references={references}
          />
        </div>
      )}

      <AsyncServiceActionMessageForm name={name} show={Boolean(selected)} />
    </>
  );
}
